<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import EditData from "./edit-data"
import EditLocation from "./edit-location"
import EditEquipment from "./edit-equipment"
/**
 * Form Validation component
 */
export default {
  page: {
    title: "Form Edit Treatment",
    meta: [{ label: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, EditData, EditLocation, EditEquipment },
  data() {
    return {
      title: "Form Edit Treatment",
      items: [
        {
          text: "Home",
          href: "/home"
        },
        {
          text: "Treatments",
          href: "/treatment"
        },
        {
          text: "Edit Treatment",
          active: true
        }
      ],
      tabActive: 0
    };
  },
  mounted() {

    switch(this.$route.hash) {
      case "#data":
        this.tabActive = 0
        break;
      case "#location":
        this.tabActive = 1
        break;
      case "#equipment":
        this.tabActive = 2
        break;
      default:
        this.tabActive = 0
        break;
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <b-tabs v-model="tabActive" justified nav-class="nav-tabs-custom" content-class="p-3">
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-home"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Data Treatment</span>
                </template>
                <EditData></EditData>
              </b-tab>
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-user"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Locations</span>
                </template>
                <EditLocation></EditLocation>
              </b-tab>
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-envelope"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Equipments</span>
                </template>
                <EditEquipment></EditEquipment>
              </b-tab>
              <!-- <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-cog"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Employees</span>
                </template>
              </b-tab> -->
            </b-tabs>
          </div>
          <!-- end card-body -->
        </div>
      </div>
      <!-- end col-->
    </div>
    <!-- end row -->
  </Layout>
</template>